import { render, staticRenderFns } from "./CRMCreateFlowRedirect.vue?vue&type=template&id=556ab76f&scoped=true"
import script from "./CRMCreateFlowRedirect.vue?vue&type=script&lang=js"
export * from "./CRMCreateFlowRedirect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "556ab76f",
  null
  
)

export default component.exports